import { useTranslation } from 'react-i18next';
import { getAssetDisplayName } from '@monorepo/client-common';
import { ToggleButton, ToggleButtonGroup, Typography } from '@monorepo/nova-ui';
import { CartType, OptionalAssets } from '@monorepo/types';
import { getAssetItemCount } from '../../utils';

interface CartAssetTabsProps {
  cart: CartType;
  assets: OptionalAssets[];
  selectedAsset: OptionalAssets | null;
  onAssetChange: (asset: OptionalAssets) => void;
}

export const CartAssetTabs = ({
  cart,
  assets,
  selectedAsset,
  onAssetChange,
}: CartAssetTabsProps) => {
  const { t } = useTranslation(['purchase']);
  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newAsset: OptionalAssets | null,
  ) => {
    if (newAsset !== null) {
      onAssetChange(newAsset);
    }
  };

  return (
    <ToggleButtonGroup
      value={selectedAsset}
      exclusive
      onChange={handleChange}
      sx={{
        justifyContent: 'center',
      }}
    >
      {assets.map((asset) => {
        const itemCount = getAssetItemCount(cart, asset);
        return (
          <ToggleButton key={asset} value={asset} color="primary" size="sm">
            <Typography
              sx={(theme) => ({
                fontSize: theme.typography.body2.fontSize,
                color: 'inherit',
              })}
            >
              {getAssetDisplayName(asset, t)} ({itemCount})
            </Typography>
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
};
